export class SHIPPER_APP_ORDER_CONFIGURATION {
  isEnabled?: boolean;
  isEnabledDynamicTimeWindow?: boolean;
  isEnabledCreateOrderForm?: boolean;
  isEnabledEditOrderForm?: boolean;
  schedulingMethodConfiguration?: string | undefined;
  timeWindowConfiguration?: { isEnabled: boolean, timeWindowType: string | undefined};
  addressConfiguration?: { isEnabled: boolean, locationTypes: string[] | undefined};

  constructor(shipperOrderPortalConfiguration: SHIPPER_APP_ORDER_CONFIGURATION = {
    isEnabled: false,
    isEnabledDynamicTimeWindow: false,
    isEnabledCreateOrderForm: false,
    isEnabledEditOrderForm: false,
    schedulingMethodConfiguration: undefined,
    timeWindowConfiguration: {isEnabled: false, timeWindowType: undefined},
    addressConfiguration: {isEnabled: false, locationTypes: []}
    }) {
    this.isEnabled = shipperOrderPortalConfiguration?.isEnabled;
    this.isEnabledDynamicTimeWindow = shipperOrderPortalConfiguration?.isEnabledDynamicTimeWindow;
    this.isEnabledCreateOrderForm = shipperOrderPortalConfiguration?.isEnabledCreateOrderForm;
    this.isEnabledEditOrderForm = shipperOrderPortalConfiguration?.isEnabledEditOrderForm;
    this.schedulingMethodConfiguration = shipperOrderPortalConfiguration?.schedulingMethodConfiguration;
    this.timeWindowConfiguration = shipperOrderPortalConfiguration?.timeWindowConfiguration;
    this.addressConfiguration = shipperOrderPortalConfiguration?.addressConfiguration;
  }

}

export class SHIPPER_APP_CUSTOMER_CONFIGURATION {
  isEnabled?: boolean;
  isEnabledCreateCustomer?: boolean;
  isEnabledEditCustomer?: boolean;

  constructor(shipperCustomerPortalConfiguration: SHIPPER_APP_CUSTOMER_CONFIGURATION = {
    isEnabled: false,
    isEnabledCreateCustomer: false,
    isEnabledEditCustomer: false
  }) {
    this.isEnabled = shipperCustomerPortalConfiguration?.isEnabled;
    this.isEnabledCreateCustomer = shipperCustomerPortalConfiguration?.isEnabledCreateCustomer;
    this.isEnabledEditCustomer = shipperCustomerPortalConfiguration?.isEnabledEditCustomer;
  }
}

export class SHIPPER_APP_PAYMENT_CONFIGURATION {
  isEnabled?: boolean;

  constructor(shipperPaymentPortalConfiguration: SHIPPER_APP_PAYMENT_CONFIGURATION = {
    isEnabled: false
  }) {
    this.isEnabled = shipperPaymentPortalConfiguration?.isEnabled;
  }

}

export class ShipperPortalConfiguration {
  SHIPPER_APP_ORDER_CONFIGURATION?: SHIPPER_APP_ORDER_CONFIGURATION;
  SHIPPER_APP_CUSTOMER_CONFIGURATION?: SHIPPER_APP_CUSTOMER_CONFIGURATION;
  SHIPPER_APP_PAYMENT_CONFIGURATION?: SHIPPER_APP_PAYMENT_CONFIGURATION;

  constructor(shipperPortalConfiguration: ShipperPortalConfiguration) {
    this.SHIPPER_APP_ORDER_CONFIGURATION = new SHIPPER_APP_ORDER_CONFIGURATION(shipperPortalConfiguration.SHIPPER_APP_ORDER_CONFIGURATION);
    this.SHIPPER_APP_CUSTOMER_CONFIGURATION = new SHIPPER_APP_CUSTOMER_CONFIGURATION(shipperPortalConfiguration.SHIPPER_APP_CUSTOMER_CONFIGURATION);
    this.SHIPPER_APP_PAYMENT_CONFIGURATION = new SHIPPER_APP_PAYMENT_CONFIGURATION(shipperPortalConfiguration.SHIPPER_APP_PAYMENT_CONFIGURATION);
  }

}
